import Paper from '@material-ui/core/Paper';
import Container from '@material-ui/core/Container';
import PrivateLayout from '../../../../layouts/private';
import OrderForm from './form';

export default function OrdersAddScreen() {

    return (
        <PrivateLayout screenTitle="Create an Order" screenPath="content.orders.add">
            <Paper elevation={2} style={{ paddingTop: 24, paddingBottom: 24, marginBottom: 14 }}>
                <Container>

                    <OrderForm isAdd />

                </Container>
            </Paper>
        </PrivateLayout>
    );

}
